import React from 'react';
import { CustomFunctionTable } from './CustomFunctionTable';

export const CustomFunctionTab = (props) => {
  const { projectId, version, actions, flag, customFunctions, isReadOnly } = props;
  return (
    <>
      <CustomFunctionTable
        customFunctions={customFunctions}
        projectId={projectId}
        version={version}
        actions={actions}
        flag={flag}
        isReadOnly={isReadOnly}
      />
    </>
  );
};
